import { Code2, MessageSquare } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { useAgentStore } from '../../store/useAgentStore.js';

export default function WorkbenchSurfaceTabs() {
  const surface = useAgentStore((s) => s.code.ui.workbenchSurface || 'chat');
  const active = useAgentStore((s) => ['code', 'chat', 'plan'].includes(s.activeWorkspace));
  const reduce = useReducedMotion();
  function choose(value) {
    const store = useAgentStore.getState();
    store.setUiPref('workbenchSurface', value);
    store.setActiveWorkspace('code');
    window.dispatchEvent(new CustomEvent('apolo:workbenchSurface', { detail: value }));
  }
  return <div className="workbench-surface-tabs" role="tablist" aria-label="Área de trabalho" onKeyDown={(event) => {
    if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
      event.preventDefault();
      const next = event.key === 'Home' ? 'chat' : event.key === 'End' ? 'code' : surface === 'chat' ? 'code' : 'chat';
      choose(next);
      event.currentTarget.querySelector(`#tab-${next}`)?.focus();
    }
  }}>
    {[['chat', 'Chat', MessageSquare], ['code', 'Code', Code2]].map(([value, label, Icon]) => <button key={value} id={`tab-${value}`} type="button" role="tab" aria-controls="tabpanel-code" aria-selected={active && surface === value} tabIndex={surface === value ? 0 : -1} onClick={() => choose(value)}>
      {active && surface === value && <motion.span className="workbench-surface-active" layoutId="workbench-surface" transition={reduce ? { duration: 0 } : { type: 'spring', stiffness: 450, damping: 35 }} />}
      <Icon size={14} /><span>{label}</span>
    </button>)}
  </div>;
}
